import { gql } from '@apollo/client';

export const fetchInvoicesForCloud = gql`
  query searchInvoicesQuery($searchOptions: InvoiceWhereFilter) {
    invoiceSearch(searchOptions: $searchOptions) {
      totalHits
      results {
        id
        invoiceNumber
        sourceId
        invoiceNumber
        domain
        status
        createdTimestamp
        billingGroupId
        total
        creditCard {
          last4Numbers
          cardHolderName
          expirationMonth
          expirationYear
          brand
        }
        refunds {
          id
          type
          creditNoteNumber
          sourceSystem
          total
          currency
          status
          arn
        }
        dunningStatus {
          attemptCount
          paymentRetryDate
          errorCode
          declineCode
          nextPaymentAttempDate
        }
        sourceSystem
        billTo {
          domain
          fullName
          organization
          email
          address {
            address1
            address2
            city
            country
            phone
            postalCode
            state
          }
          taxId
        }
        shipTo {
          domain
          fullName
          organization
          email
          address {
            address1
            address2
            city
            country
            phone
            postalCode
            state
          }
          taxId
        }
        transactionAccountId
        paymentCurrency
        paymentMethod
        dueDate
        pdfLink
        grandTotal
        invoiceDueDays
      }
    }
  }
`;
